"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _environment = _interopRequireDefault(require("./environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var deepCompareEquals = function deepCompareEquals(value1, value2) {
  var isEqualValue = false;
  if (typeof value1 === 'function' || _environment.default.isClient && value1 instanceof HTMLElement) {
    isEqualValue = value1 === value2;
  } else {
    isEqualValue = (0, _isEqual.default)(value1, value2);
  }
  return isEqualValue;
};
var _default = deepCompareEquals;
exports.default = _default;